'use client'
/* eslint-disable @next/next/no-img-element */
import Script from 'next/script'
import { YANDEX_METRIKA_ID } from '@/shared/constants/stubs'

export const YaAnalyticsScript = () => {
  return (
    <>
      <Script
        id="metrika-counter"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            (function(m,e,t,r,i,k,a){
              m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
              m[i].l=1*new Date();
              for (var j = 0; j < document.scripts.length; j++) {
                if (document.scripts[j].src === r) { return; }
              }
              k=e.createElement(t),a=e.getElementsByTagName(t)[0],
              k.async=1,k.src=r,a.parentNode.insertBefore(k,a)
            })(window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

            ym(${YANDEX_METRIKA_ID}, "init", {
              defer: true,
              clickmap: true,
              trackLinks: true,
              accurateTrackBounce: true
            });
          `,
        }}
      />
      <noscript>
        <div>
          <img
            src={`https://mc.yandex.ru/watch/${YANDEX_METRIKA_ID}`}
            alt=""
            style={{ position: 'absolute', left: '-9999px' }}
            width={1}
            height={1}
          />
        </div>
      </noscript>
    </>
  )
}
